module.exports = new __parcel__URL__("8541.838e03c4.jpg").toString();